var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4,20.161L16.129,8L11.2,8L11.2,0L20.8,0C20.818,0 20.835,0.005 20.853,0.01C20.868,0.015 20.883,0.019 20.899,0.021C21.042,0.029 21.179,0.058 21.314,0.102C21.33,0.108 21.345,0.113 21.361,0.118C21.396,0.129 21.431,0.14 21.464,0.155C21.634,0.234 21.795,0.331 21.933,0.469L31.533,10.069C31.67,10.206 31.768,10.368 31.846,10.538L31.899,10.688C31.944,10.822 31.971,10.96 31.979,11.101C31.981,11.117 31.985,11.132 31.99,11.147C31.995,11.165 32,11.182 32,11.2L32,28.8C32,30.565 30.565,32 28.8,32L9.6,32C7.835,32 6.4,30.565 6.4,28.8L6.4,20.161ZM20.8,11.2L20.8,3.2L28.8,11.2L20.8,11.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.2,-0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.703,27.2L12.703,24.387L13.705,24.387C14.472,24.387 15.071,24.16 15.504,23.705C15.937,23.251 16.153,22.632 16.153,21.848C16.153,21.064 15.934,20.427 15.494,19.936C15.058,19.445 14.472,19.2 13.736,19.2L11.2,19.2L11.2,27.2L12.703,27.2Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.16,19.2L17.16,27.2L19.088,27.2C19.994,27.2 20.705,26.901 21.219,26.304C21.737,25.704 21.996,24.878 21.996,23.826L21.996,22.53C21.986,21.497 21.722,20.684 21.204,20.09C20.689,19.497 19.997,19.2 19.128,19.2L17.16,19.2Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.919,23.936L24.583,23.936L24.583,27.2L23.08,27.2L23.08,19.2L27.2,19.2L27.2,20.546L24.583,20.546L24.583,22.596L26.919,22.596L26.919,23.936Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6,0,0,1.6,-2.2,-3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.585,16.4L9.939,16.4L9.939,14.841L10.594,14.841C10.762,14.844 10.897,14.919 10.997,15.068C11.097,15.214 11.147,15.413 11.147,15.662C11.147,15.903 11.098,16.086 11,16.212C10.902,16.337 10.764,16.4 10.585,16.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6,0,0,1.6,-2.2,-3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.665,18.162L13.665,14.841L14.006,14.841C14.298,14.851 14.505,14.948 14.626,15.133C14.748,15.316 14.808,15.642 14.808,16.108L14.808,16.977C14.802,17.412 14.735,17.719 14.607,17.898C14.479,18.074 14.259,18.162 13.946,18.162L13.665,18.162Z",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6,0,0,1.6,-3.2,-3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,2L8,8L10,8L6,13L2,8L4,8L4,2L8,2Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a2cbf1f3.svg";
export { ForwardRef as ReactComponent };